/**
 * ライトボックス機能
 * 
 * GLightboxを使用して画像ギャラリーのポップアップ表示を実装
 * 既存のcboxElementクラスとdata-lightbox属性に対応
 */

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

let lightboxInstance = null;

/**
 * ライトボックスの初期化
 * cboxElementクラスを持つ要素をGLightboxで初期化
 */
export function setupLightbox() {
  // 既存のインスタンスを破棄
  if (lightboxInstance) {
    lightboxInstance.destroy();
    lightboxInstance = null;
  }

  // cboxElementクラスを持つ要素を取得
  const lightboxElements = document.querySelectorAll('.cboxElement');
  
  if (lightboxElements.length === 0) {
    return null;
  }

  // 既存のdata-lightbox属性をdata-glightboxに変換
  lightboxElements.forEach((element) => {
    if (element.hasAttribute('data-lightbox')) {
      const lightboxGroup = element.getAttribute('data-lightbox');
      element.setAttribute('data-glightbox', lightboxGroup);
    } else {
      // data-lightbox属性がない場合はデフォルトのグループ名を設定
      element.setAttribute('data-glightbox', 'photos');
    }
  });

  // GLightboxを初期化
  lightboxInstance = GLightbox({
    selector: '.cboxElement',
    touchNavigation: true,
    loop: true,
    autoplayVideos: false,
    openEffect: 'fade',
    closeEffect: 'fade',
    slideEffect: 'slide',
    moreText: 'もっと見る',
    moreLength: 60,
    closeButton: true,
    touchFollowAxis: true,
    keyboardNavigation: true,
    closeOnOutsideClick: true,
    dragAutoSnap: false,
    zoomable: true,
    draggable: true,
  });

  return lightboxInstance;
}

/**
 * ライトボックスを再初期化
 * タブ切り替えなどでDOMが変更された後に呼び出す
 */
export function reinitializeLightbox() {
  return setupLightbox();
}

